import { getMyRoom } from './AuthService';
import { autoRejoinRoom, getRoomData } from './GameService';
import { customStorage } from './CommonService';
import { STO_PLAYER_NAME } from '../constants/commonConstants';
import { rememberRoomMembership, rememberRoomCredential, getRoomCredential } from './RoomSession';

// Read-only restoration is not a new admission/rejoin. Only the server can
// confirm whether this account still owns the active seat in this room.
export const restoreActiveRoom = async (roomId, playerId, isCurrent = () => true, signal) => {
    const options = { timeout: 5000, signal };
    const credential = getRoomCredential(roomId);
    const membership = await getMyRoom({ ...options, _roomId: roomId,
        headers: credential ? { 'X-PWF-Room-Credential': credential } : {} });
    if (!isCurrent()) return null;
    if (!membership?.isJoined && membership?.autoRejoinEligible && membership.roomId === roomId && membership.playerId === playerId) {
        const restored = await autoRejoinRoom(roomId, customStorage.getItem(STO_PLAYER_NAME) || 'Player');
        membership.isJoined = true;
        membership.membershipVersion = restored.membershipVersion;
        membership.roomCredential = restored.roomCredential;
    }
    if (!membership?.isJoined || membership.roomId !== roomId || membership.playerId !== playerId || !membership.membershipVersion) {
        window.dispatchEvent(new CustomEvent('pwf-room-membership-ended', { detail: {
            roomId, code: membership?.roomId ? 'ROOM_MEMBERSHIP_ENDED' : 'ROOM_NOT_FOUND'
        } }));
        return null;
    }
    rememberRoomMembership(roomId, membership.membershipVersion);
    rememberRoomCredential(roomId, membership.roomCredential);
    const snapshot = await getRoomData(roomId, playerId, options);
    return isCurrent() ? snapshot : null;
};
